import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import TimeInput from 'material-ui-time-picker';
import { FormControl, FormControlLabel, Grid, RadioGroup, withStyles, WithStyles, InputAdornment } from '@material-ui/core';
import { styles } from './style';
import { MyPATMultiSearch, MyPATSelect, MyPATTextField } from '../../../../common';
import _ from 'lodash';
import { Goal } from '../../../types/interfaces/Goal';
import * as courseManagementActions from '../../../actions';
import { courseStyles } from '../../../styles';
import { getActiveGoals } from '../../../actions';
import { ExistingScheduledTest } from '../../../types/interfaces/ExistingScheduledTest';
import MyPATCalendar from '../../../../common/MyPATCalendar';
import { MyPATDialog } from '../../../../common';
import {
  handleOnChange, initialAddTestValues, refinedEditData,
  previewData, handleOnChangeErrors, defaultPaperDetail
} from './helpers';
import courseManagementServices from '../../../service/courseManagementServices';
import contentService from '../../../../mylibrary/services/contentService';



interface AddTestDialogState {
  open: boolean;
  existingTest: boolean;
  scheduledTest: boolean;
  check: boolean;
  scheduledTests: ExistingScheduledTest[];
  scheduledTestsNames: { name: string; id: string; testId: string }[];
  selectedTest: any;
  isTestMapped: boolean;
  coursesByScheduleId: any[];
  preparedCourseData: any[];
  mapTestSuggestions: any[];
  mapTestSuggestionNames: any[];
  activeGoals: Goal[];
  errorMessage: any;
  overAllData: any;
  startDate: any;
  endDate: any;
  goalsDriller: any;
  isSubmitEnabled: boolean;
  mapScheduleTest: any;
  errorText: any;
  errors: {
    testName: any;
    testSyllabus: any;
    maxAttempt: any;
    questionsCount: string;
    blockRevisionTime: any;
    duration: any;
    goal: any;
    scheduleDate: any;
    scheduleEndDate: any;
    mappedTestValid:string;
  };
  [key: string]: any;
  errorBool: boolean;
  regexp: any;
  courseId: string;
  selectOptions: any;
  mapTestName: string;
  selectTouch: boolean;
  phaseBool: boolean;
}
interface Syllabus {
  text: string
}

interface PaperDetail {
  syllabus: Syllabus,
  id: string,
  name: string,
  type: string
}
interface AddTestFormErrors {
  paperDetail: PaperDetail,
  testType: string,
  duration: string,
  status: string,
  codeName: string,
  displayName: string,
  scheduleID: string,
  scheduleDate: string,
  startTime: string,
  scheduleEndDate: string,
  endTime: string,
  maxAttempt: string,
  blockRevisionTime: string,
}

interface AddTestDialogProps extends WithStyles<typeof styles> {
  title: String;
  dropDownStringArray: any;
  textFieldStringArray: any;
  dialogButtonName: String;
  isExistingTest: boolean;
  durationAttemptRevision: any;
  buttonName: String;
  isRequiredMapTest: boolean;
  isExistingAndScheduledTest: boolean;
  isRequiredDate: boolean;
  courseId: string;
  fetchExistingScheduledTests: Function;
  existingScheduledTests: ExistingScheduledTest[];
  mapTestSuggestions: any[];
  fetchMapTestSuggestions: Function;
  courseDetails: any;
  goals: Goal[];
  onAddTest: Function;
  handleToggleOpen: Function;
  open: boolean;
  getActiveGoals: Function;
  fetchCoursesByScheduleId: Function;
  coursesByScheduleId: any[];
  fromCombo?: boolean;
  onSaveCombo?: Function;
  handleAddTest?: (data: any) => void;
  courses: any;
  totalGoalsForComboCourse: any;
  scheduledTestData: any;
  editMode: boolean;
  editTestDetails: any;
  coursePlanId?: string;
  isPreview?: boolean;
  fetchScheduleTests: Function;
  testIndex?: number;
  phase: any;
  handleDeleteTestFromComboCourse?: Function;
  treeData: any;
  mappedTest: string;
  courseIdData: string;
  testType: string;
  test: any;
  testDurationFromAPI: number;
  questionsCountFromAPI: number;
  phaseIndex: number;
  packageEndDate: string | Date;
  isExtraTests?: boolean;
  viewPlanData: any;
}

class AddTestDialog extends React.Component<AddTestDialogProps, AddTestDialogState> {
  constructor(props: AddTestDialogProps) {
    super(props);
    this.state = {
      ...initialAddTestValues
    }
  }
  setActiveGoals = (goalData: any) => {
    this.setState({
      activeGoals: goalData,
    });
  };
  componentDidMount = () => {
    
    const { coursePlanId, editTestDetails, courseIdData } = this.props;
    
    this.setGoalsDriller(_.get(this.state.selectedTest, 'courseId', ''));

    const { selectedTest } = this.state;
    if (this.props.isPreview) {
      previewData(selectedTest, editTestDetails, this.handleSetState);
    }
    coursePlanId && this.props.fetchExistingScheduledTests(coursePlanId);
    // this.setScheduleTests();
    this.setInitialOverAllData();
    this.handleGoalsPart();
    // this.props.fromCombo &&
    //   this.setState({
    //     scheduledTestsNames: this.props.scheduledTestData,
    //   });
    this.setState({ selectOptions: this.renderSelectTestOptions() });
    if (this.props.editMode) {
      this.setState({ selectTouch: true });
    }
  
    
  };
  resetErrors = () => {
    this.setState({
      errors: JSON.parse(JSON.stringify(initialAddTestValues.errors))
    })
  }
  // use this function further
  setCourseId = () => {
    const { overAllData } = this.state;
    const { goals = [] } = this.props;
    if (overAllData && Object.keys(overAllData).length && overAllData.courseId) {
      const filterData = goals.filter((ele) => ele._id === overAllData.courseId)[0];
    }
  }

  setInitialOverAllData = () => {
    this.setState({
      overAllData: { ...this.state.overAllData, type: 'full' }
    });
  }

  handleGoalsPart = () => {
    this.props.getActiveGoals();
    this.setActiveGoals(this.props.totalGoalsForComboCourse);
  }

  componentDidUpdate = (prevProps: AddTestDialogProps, prevState: AddTestDialogState) => {
    const prevCourseId = _.get(prevState, 'selectedTest.courseId', '');
    const currCourseId = _.get(this.state, 'selectedTest.courseId', '');

    if(prevCourseId !== currCourseId){
      this.setGoalsDriller(currCourseId);
    }

    if (prevProps.scheduledTestData !== this.props.scheduledTestData) {
      this.setState({ selectOptions: this.renderSelectTestOptions() });
    }

    if (prevProps.mapTestSuggestions !== this.props.mapTestSuggestions) {
      this.setState(
        {
          mapTestSuggestions: this.props.mapTestSuggestions,
        },
        () => this.setMapTestSuggestionNames(this.props.mapTestSuggestions)
      );
    }
    if (prevProps.editMode !== this.props.editMode) {
      const { selectedTest} = this.state;
      const { editTestDetails } = this.props;
      refinedEditData(selectedTest, editTestDetails, this.handleSetState);
      if (this.props.editMode) {
        this.setState({ selectTouch: true });
      }
    }

    if (prevProps.coursesByScheduleId !== this.props.coursesByScheduleId) {
      this.setState(
        {
          coursesByScheduleId: this.props.coursesByScheduleId,
        },
        () => this.prepareCoursesForEditTestDialog(this.props.coursesByScheduleId)
      );
    }
    if (prevProps.open !== this.props.open) {
      this.resetErrors();
      if (this.props.open && !this.props.editMode) {
        this.setState({
          selectedTest: { ...JSON.parse(JSON.stringify(initialAddTestValues.selectedTest)), paperDetail: { ...defaultPaperDetail.paperDetail } },
          errorBool: false,
          phaseBool: false,
          mapTestName: initialAddTestValues.mapTestName,
          isTestMapped: false,
        })
      }
    }
    if(prevState.mapTestName!==this.state.mapTestName){
      const {errors}=this.state;
      const updatedFormErrors={...errors};
     if(!this.state.mapTestName){
       updatedFormErrors.mappedTestValid='';
       this.setState({errors:updatedFormErrors});
     }else{ 
      const contentId=this.state.mapTestName.split('|')[0];
      this.checkIfTestExistInGoal(contentId,currCourseId).then((apiError)=>{
        if(apiError){
          updatedFormErrors.mappedTestValid=apiError; 
        }else{
          updatedFormErrors.mappedTestValid='';
        } 
        this.setState({errors:updatedFormErrors});
      })
     }
    } 
  };

  prepareCoursesForEditTestDialog = (courseRawData: any[]) => {
    let preparedCourseData: any[] = [];
    // Create array of CourseInfo object
    this.setState({
      preparedCourseData,
    });
  };

  setScheduledTestsNames = (testData: any) => {
    let cloneTestData = JSON.parse(JSON.stringify(testData)) || [];
    const scheduledTestsNames = cloneTestData.map((test: any) => ({
      name: test.displayName,
      id: test._id,
      testId: test.paperDetail.id,
    }));
    return [...scheduledTestsNames];
  };

  setMapTestSuggestionNames = (data: any[]) => {
    const suggestionNames = data && data.length && data.map((obj) => ({
      title: obj.title,
      id: obj.content_Id,
      type: obj.contentSubTypeCode,
      contentId: obj.contentId
    }));
    this.setState({
      mapTestSuggestionNames: suggestionNames || [],
    });
  };

  handleToggleOpen = () => {
    this.setState((previousState: any) => ({
      open: !previousState.open,
    }));
  };

  handleToggleRadiio = () => {
    this.setState((previousState: any) => ({
      existingTest: !previousState.existingTest,
      scheduledTest: !previousState.scheduledTest,
      check: !previousState.check,
      isTestMapped: !previousState.scheduledTest === true && false,
      selectedTest: { ...initialAddTestValues.selectedTest, paperDetail: { ...defaultPaperDetail.paperDetail } }
    }));
  };

  hasError = (name: any) => {
    const { testType , isExtraTests } = this.props;
    const isMaxAttemptRequired = testType !== 'week' && !isExtraTests;
    const { errors } = this.state;
    if (name === 'testName' && errors.testName !== '') {
      return true;
    } else if (name === 'testSyllabus' && errors.testSyllabus !== '') {
      return true;
    } else if (name === 'maxAttempt' && isMaxAttemptRequired && errors.maxAttempt !== '') {
      
      return true;
    } else if (name === 'duration' && errors.duration !== '') {
      return true;
    } else if (name === 'Select Goal' && errors.goal !== '') {
      return true;
    } else if (name === 'scheduleDate' && errors.scheduleDate !== '') {
      return true;
    } else if (name === 'scheduleEndDate' && errors.scheduleEndDate !== '') {
      return true;
    } else if (name === 'questionsCount' && errors.questionsCount !== '') {
      return true;
    } else return false;
  };

  getHelperText = (name: any) => {
    const { errors } = this.state;
    const { testType , isExtraTests } = this.props;
    const isMaxAttemptRequired = testType !== 'week' && !isExtraTests;

    if (name === 'testName') {
      return errors.testName;
    } else if (name === 'testSyllabus') {
      return errors.testSyllabus;
    } else if (name === 'maxAttempt' && isMaxAttemptRequired) {
      return errors.maxAttempt;
    }else if (name === 'duration') {
      return errors.duration;
    } else if (name === 'Select Goal') {
      return errors.goal;
    } else if (name === 'scheduleDate') {
      return errors.scheduleDate;
    } else if (name === 'scheduleEndDate') {
      return errors.scheduleEndDate;
    } else if( name === 'questionsCount'){
      return errors.questionsCount;
    }
    return '';
  };

  handleTextField = (textFieldStringArray: any) => {
    const { classes, isPreview } = this.props;
    return (
      textFieldStringArray.length &&
      textFieldStringArray.map((item: { title: string; name: string; value: string }) => (
        <>
          <Typography className={classes.inputLable}>
            {item.title}
            <span className={classes.colorRed}>*</span>
          </Typography>
          <Grid className={classes.customTextField}>
            <TextField
              id='outlined-bare'
              fullWidth={true}
              margin='normal'
              variant='outlined'
              name={item.name}
              placeholder={item.title}
              error={this.hasError(item.name)}
              helperText={this.getHelperText(item.name)}
              value={
                item.value !== 'paperDetail.syllabus.text'
                  ? this.state.selectedTest[`${item.value}`]
                  : this.state.selectedTest.paperDetail.syllabus &&
                    this.state.selectedTest.paperDetail.syllabus.text ?
                    this.state.selectedTest.paperDetail.syllabus.text.replace(/<[^>]*>/g, '') : this.state.selectedTest.paperDetail.syllabus.replace(/<[^>]*>/g, '')
              } // this.state.selectedTest in string
              onChange={(e) => this.handleChange(e)}
              disabled={isPreview}
            />
          </Grid>
        </>
      ))
    );
  };
  handleGoals = (event: any) => {
    const { name, value } = event.target;

    if (value !== '') {
      courseManagementServices.getCourseDetails(value).then((res: any) => {
        
        const { courseType, id, groupId, name, targetYear, _id } = res;
        if (res && Object.keys(res).length) {
          const goals = {
            level: 'course',
            course: { courseType, id, groupId, name, targetYear, _id },
          };
          this.setState(
            {
              goalsDriller: {
                ...goals,
              },
              overAllData: { ...this.state.overAllData, courseId: value },
              selectedTest: { ...JSON.parse(JSON.stringify(initialAddTestValues.selectedTest)), paperDetail: { ...defaultPaperDetail.paperDetail }, courseId: value },
              selectOptions: [<option value={''}>{'Select Test'}</option>],
              errorBool: false,
              phaseBool: false,
              mapTestName: initialAddTestValues.mapTestName,
              isTestMapped: false,
            },
            () => {
              if (!Object.keys(this.state.goalsDriller).length) {
                this.setState({ error: { ...this.state.error, goal: 'select by goal' } });
              } else {
                
                this.props.fetchScheduleTests({
                  itemType: 'scheduledTests',
                  id: this.state.overAllData.courseId
                })
              }
            });
        }
        handleOnChangeErrors('select goal', '', this.state, this.handleSetState);
        this.setState({ selectTouch: true });
      })

    }
    else {
      this.setState({
        overAllData: { ...this.state.overAllData, courseId: value },
        selectedTest: { ...this.state.selectedTest, courseId: value },
        selectOptions: [<option value={''}>{'Select Test'}</option>],
        selectTouch: false
      }, () => handleOnChangeErrors('select goal', 'select goal', this.state, this.handleSetState));
    }
  };

  handleDropDown = (dropDownStringArray: any) => {
    const { isPreview } = this.props;
    const { classes } = this.props;
    
    return (
      dropDownStringArray.length &&
      dropDownStringArray.map((item: String) => (
        <>
          <Typography className={classes.inputLable}>{item}</Typography>
          <Grid className={classes.dialogCustomSelect}>

            <MyPATSelect
              fullWidth={true}
              value={this.state.selectedTest.courseId}
              name='goals'
              onChange={(e: any) => item === 'Select goal' && this.handleGoals(e)}
              error={item === 'Select goal' ? this.hasError('Select Goal') : false}
              helperText={item === 'Select goal' ? this.getHelperText('Select Goal') : ''}
              disabled={isPreview || this.props.editMode}
            // inputClass={classes.selectOrgStyle}
            >
              {item === 'test' ? this.renderSelectTestOptions() : this.renderSelectGoalOptions()}
            </MyPATSelect>
          </Grid>
          <br />
        </>
      ))
    );
  };

  handleDuration = (durationAttemptRevision: any) => {
    const { classes, isPreview, testDurationFromAPI, questionsCountFromAPI } = this.props;
    const { isTestMapped }  = this.state;
    const { testType , isExtraTests } = this.props;
    const isMaxAttemptRequired = testType !== 'week' && !isExtraTests;

    return (
      durationAttemptRevision.length &&
      durationAttemptRevision.map((item: { title: string; name: string; value: string }) => (
        <Grid item xs={item.value === 'duration' || item.value === 'maxAttempt' ? 3 : 6}>
           <Typography className={classes.inputLable}>
            {item.title}
            {(item.value !== 'maxAttempt' || isMaxAttemptRequired) && item.name != 'blockRevisionTime'?<span className={classes.colorRed}>*</span>:<span></span>}
          </Typography>
          <Grid className={classes.dialogCustomInput}>
            <Grid className={classes.customTextField}>
              <MyPATTextField
                id='outlined-bare'
                fullWidth={true}
                margin='normal'
                variant='outlined'
                name={item.name}
                value={
                  !isTestMapped ?
                  this.state.selectedTest[`${item.value}`] :
                  (
                    item.value === 'duration' ? testDurationFromAPI : (
                      item.value === 'questionsCount' ? questionsCountFromAPI :
                      this.state.selectedTest[`${item.value}`]
                    )
                  )
                }
                error={this.hasError(item.name)}
                helperText={this.getHelperText(item.name)}
                onChange={(e: any) => this.handleChange(e)}
                disabled={isPreview 
                  || (
                    (item.value === 'duration' && isTestMapped) || 
                    (item.value === "questionsCount" && isTestMapped && +this.state.selectedTest[`${item.value}`] > 0)
                    // (item.value === "duration" && this.state.selectedTest.mappedTestName.length > 0) ||
                    // (item.value === "questionsCount" && this.state.selectedTest.mappedTestName.length > 0)
                )
              }
                endAdornment={item.name === 'blockRevisionTime' && (
                  <InputAdornment position="end">
                    <Typography
                      variant="subheading"
                      style={{ color: '#999', paddingRight: '10px' }}> (in Days)
               </Typography>
                  </InputAdornment>
                )}
              />
            </Grid>
          </Grid>
        </Grid>
      ))
    );
  };


  handleDateErrorOnSelectedTest = (selectedTest: any, overAllData: any) => {
    const updatedSelectedTest = { ...selectedTest }
    let updateOverAllData = { ...overAllData };
    let start;
    let end;
    this.props.phase &&
      this.props.phase.startDate &&
      (start = new Date(this.props.phase.startDate));
    this.props.phase && this.props.phase.endDate &&
      (end = new Date(this.props.phase.endDate));
    let scheduleDate = updatedSelectedTest.scheduleDate && new Date(updatedSelectedTest.scheduleDate);
    let scheduleEndDate = updatedSelectedTest.scheduleEndDate && new Date(updatedSelectedTest.scheduleEndDate);
    if (end) {
      if ((start &&
        scheduleDate
        && (scheduleDate.getTime() < start.getTime()
          || scheduleDate.getTime() > end.getTime()))
      ) {
        this.setState({ phaseBool: true });
      } else this.setState({ phaseBool: false });
    } else {
      if (start && scheduleDate && (scheduleDate.getTime() < start.getTime() || scheduleEndDate.getTime() > start.getTime())) {
        this.setState({ phaseBool: true });
      } else this.setState({ phaseBool: false });
    }
    if (scheduleDate && scheduleEndDate && scheduleDate.getTime() > scheduleEndDate.getTime()) {
      this.setState({
        errorBool: true
      })
    }
    else {
      this.setState({
        errorBool: false
      })
    }
    this.setState({
      selectedTest: updatedSelectedTest,
      // formErrors: updatedFormErrors,
      overAllData: updateOverAllData
    })
  }
  handleDateChange = (date: any, type: string) => {
    localStorage.removeItem('previousData');
    const updatedSelectedTest = { ...this.state.selectedTest }
    let updatedFormErrors = { ...this.state.formErrors }
    const { overAllData = {} } = this.state;
    let updateOverAllData = { ...overAllData };
    switch (type) {
      case 'startDate':
        updatedSelectedTest.scheduleDate = date;
        updateOverAllData.startDate = date;
        updatedFormErrors.scheduleDate = ''
        break;
      case 'endDate':
        updatedSelectedTest.scheduleEndDate = date;
        updateOverAllData.endDate = date;
        break;

      default:
    }
    const start = new Date(updateOverAllData.startDate);
    const end = new Date(updateOverAllData.endDate);
    if (updatedSelectedTest.scheduleEndDate !== '' && start.getTime() > end.getTime()) {
      this.setState({ errorBool: true });
    } else this.setState({ errorBool: false, phaseBool: false });
    this.setState({
      selectedTest: updatedSelectedTest,
      formErrors: updatedFormErrors,
      overAllData: updateOverAllData
    })
  }

  removeEndDate(type: string) {
    if (type === 'End Date & Time') {
      const updatedSelectedTest = { ...this.state.selectedTest };
      const overAllData = { ...this.state.overAllData };
      let updatedFormErrors = { ...this.state.formErrors };
      updatedSelectedTest.scheduleEndDate = '';
      updatedFormErrors.scheduleEndDate = '';
      overAllData.endDate = '';
      this.setState({ selectedTest: updatedSelectedTest, formErrors: updatedFormErrors, overAllData });
      localStorage.setItem('previousData', JSON.stringify(updatedSelectedTest.scheduleEndDate))
    }
  }

  handleTimeChange = (time: any, type: string) => {
    const { overAllData = {} } = this.state;
    const newTime = new Date(time);
    const hours = newTime.getHours();
    const minutes = newTime.getMinutes();
    const seconds = newTime.getSeconds();
    const milliseconds = newTime.getMilliseconds();
    const updatedSelectedTest = { ...this.state.selectedTest };
    const { scheduleDate, scheduleEndDate } = updatedSelectedTest;
    switch (type) {
      case 'startTime':
        let tempDate = new Date(scheduleDate);
        tempDate.setHours(hours, minutes, seconds, milliseconds);
        updatedSelectedTest.scheduleDate = tempDate;
        overAllData.startDate = tempDate;
        break;
      case 'endTime':
        tempDate = new Date(scheduleEndDate);
        tempDate.setHours(hours, minutes, seconds, milliseconds);
        updatedSelectedTest.scheduleEndDate = tempDate;
        overAllData.endDate = tempDate;
        break;
    }
    this.setState({
      selectedTest: { ...updatedSelectedTest },
      overAllData,
    });
  };

  handleDateKey = (key: string) => {
    const { selectedTest = {} } = this.state;
    switch (key) {
      case 'startDate':
        return selectedTest.scheduleDate ? new Date(selectedTest.scheduleDate) : '';
      case 'startTime':
        return selectedTest.scheduleDate ? new Date(selectedTest.scheduleDate) : new Date();
      case 'endDate':
        return selectedTest.scheduleEndDate ? new Date(selectedTest.scheduleEndDate) : '';
      case 'endTime':
        return selectedTest.scheduleEndDate ? new Date(selectedTest.scheduleEndDate) : new Date();
    }
  }

  handleDisableCalender = (key: string) => {
    const { selectedTest: { scheduleDate = '', scheduleEndDate = '' } = {} } = this.state;
    if (key === 'endDate' && !scheduleDate) {
      return true;
    }
    return false;
  }
  getTestMinDate = () => {
    if(this.props.phase) {
      const date = new Date(this.props.phase.startDate);
      date.setHours(0,0,0);

      return date;
    }
  }
  getTestMaxDate = () => {
    const { packageEndDate, treeData, phase,  phaseIndex, isExtraTests, testType, viewPlanData, isPreview } = this.props;
    let date;
    const data = isPreview ? viewPlanData : treeData;
    if(!isExtraTests && testType === 'week') {
      date =  new Date(phase.endDate);
      // date.setDate(date.getDate() - 1);

    } else {
      if(phaseIndex === (data.phases.length - 1)){
        date = packageEndDate
      } else {
        const nextPhase = data.phases[phaseIndex + 1];
        date = nextPhase.startDate
        date = new Date(date)
        date.setDate(date.getDate() - 1)
      }
      date = new Date(date)
    }

    date.setHours(23,59,59);
    return date;
  }

  handleStartEndDate = () => {
    const { classes, editTestDetails, treeData, isPreview, viewPlanData } = this.props;
    let conflictPhase = false;
    const data = isPreview ? viewPlanData : treeData;
    let expiryData = data ? data.endDate : {};
    let startDate = data ? data.startDate : {};
    editTestDetails && editTestDetails.conflict && (conflictPhase = true);
    const DateVals = [
      {
        label: 'Start Date & Time',
        dateKey: 'startDate',
        timeKey: 'startTime',
      },
      {
        label: 'End Date & Time',
        dateKey: 'endDate',
        timeKey: 'endTime',
      },
    ];
    const { errorBool, phaseBool, selectedTest } = this.state;
    return (
      DateVals.length &&
      DateVals.map((item: { label: string; dateKey: string; timeKey: string }) => (
        <>
   
          <Grid container justify='space-between' spacing={16}>
            <Grid item xs={6}>
              <InputLabel className={classes.inputLable}>{item.label}</InputLabel>
              {item.label === 'Start Date & Time' ? <span className={classes.colorRed}>*</span> : <span style={{ color: '#666' }}>(optional)</span>}
              {item.label === 'End Date & Time' && <button className={classes.removeEndDate} disabled={this.state.selectedTest.scheduleEndDate === ''} onClick={() => {this.removeEndDate(item.label)}}>Remove</button>}
              <MyPATCalendar
                fullWidthControl
                error={item.label === 'Start Date & Time' && (errorBool || phaseBool)}
                date={this.handleDateKey(item.dateKey)}
                helperText={item.label === 'Start Date & Time' && (errorBool ? 'Start Date must be smaller than End Date' : phaseBool ? 'Date range should lie in phase duration' : '')}
                onChange={(dateVal: string) => this.handleDateChange(dateVal, item.dateKey)}
                placeholder={item.label === 'Start Date & Time' ? 'Select Start Date' : 'Select End Date'}
                // minDate={item.label === 'Start Date & Time' ? new Date(this.props.phase.startDate) : new Date(this.state.selectedTest.scheduleDate)}
                
                // Shivam, Please check getTestMinDate and getTestMaxDate methods
                minDate={!conflictPhase ? (this.getTestMinDate()) : new Date(startDate)}
                maxDate={!conflictPhase ? (this.getTestMaxDate()) : new Date(expiryData)}
                // minDate={!conflictPhase ? (item.label === 'Start Date & Time' ? this.props.phase && new Date(this.props.phase.startDate) : new Date(this.state.selectedTest.scheduleDate)) : new Date(startDate)}
                // maxDate={!conflictPhase ? (item.label === 'Start Date & Time' && this.props.phase ? this.props.phase && new Date(this.props.phase.endDate) : this.props.phase && new Date(this.props.phase.endDate)) : new Date(expiryData)}
                disabled={this.handleDisableCalender(item.dateKey)}
              />
            </Grid>
            <Grid item xs={6}>
              <InputLabel className={classes.inputLable}></InputLabel>
              <div className={classes.customTime}>
                <TimeInput
                  disableUnderline={true}
                  mode='12h'
                  value={this.handleDateKey(item.timeKey)}
                  onChange={(time: any) => { this.handleTimeChange(time, item.timeKey) }}
                  defaultValue={new Date()}
                  placeholder={
                    item.label === 'Start Date & Time'
                      ? selectedTest.scheduleDate ? null : 'Select Start Time'
                      : selectedTest.scheduleEndDate ? null : 'Select End Time'
                 }
                 disabled={this.state.selectedTest.scheduleEndDate === ''}
                />
              </div>
            </Grid>
          </Grid>
        </>
      ))
    );
  };

  handleRadioButton = () => {
    const { existingTest, scheduledTest } = this.state;
    const { classes, isPreview } = this.props;
    const radio1 = 'Add Existing Scheduled Test';
    const radio2 = 'Schedule A New Test';
    if (!isPreview) {
      return (
        <div className={classes.root}>
          <FormControl component='fieldset' >
            <RadioGroup
              classes={{
                root: classes.testRadioGroup,
              }}>
              <FormControlLabel
                control={
                  <Radio
                    color="primary"
                    checked={existingTest}
                    onChange={this.handleToggleRadiio}
                    value='e'
                    name='radio-button-demo'
                  />
                }
                label='Add Existing Scheduled Test'
              />
              <FormControlLabel
                control={
                  <Radio
                    color="primary"
                    checked={scheduledTest}
                    onChange={this.handleToggleRadiio}
                    value='e'
                    name='radio-button-demo'
                  />
                }
                // aria-label='E'
                label='Schedule A New Test'
              />
            </RadioGroup>
          </FormControl>
        </div>
      );
    } else {
      return <></>;
    }
  };

  renderSelectGoalOptions = () => {
    let options = [];
    options.push(<option value={''}>{'Select Goal'}</option>);
    _.map(this.state.activeGoals, (goal: any, index: number) =>
      options.push(
        <option key={index} value={goal.courseId}>
          {goal.courseName}
        </option>
      )
    );

    return options;
  };

  showOptions = (): any => {
    const testData: any = this.setScheduledTestsNames(this.props.scheduledTestData);
    
    return testData.map(({ name, testId }: any) =>
      <option key={testId} value={testId}>
        {name}
      </option>
    );
  }

  renderSelectTestOptions = () => {
    const selectedOptions = this.showOptions();
    let options: any = [<option value={''}>{'Select Test'}</option>, ...selectedOptions];
    return [...options];
  };

  handleSetState = (updatedValues: any) => {
    this.setState({
      ...JSON.parse(JSON.stringify(updatedValues))
    });
  };

  handleChange = (e: any) => {
    const { selectedTest, overAllData, existingTest } = this.state;
    const { testType , isExtraTests } = this.props;
    const isMaxAttemptRequired = testType !== 'week' && !isExtraTests;
    handleOnChange(e.target, selectedTest, overAllData, this.props, this.handleSetState, this.handleDateErrorOnSelectedTest);
    const { name, value } = e.target;
    handleOnChangeErrors(name, value, this.state, this.handleSetState, isMaxAttemptRequired);
  };

  checkIfTestExistInGoal=async (contentId:string,courseId:string)=>{
    const source="mapTestInCourse";
    const err= await courseManagementServices.validateMapTestIdBySource({contentId,courseId,source});  
    return err;
   }
   
  handleTestMapping = async (event: any) => {
    const { type = '', id, contentId } = event;
    let code = '';
    let testId = '';
    type ? (code = type) : (code = 'full');
    id ? (testId = id) : (testId = '000000000000000000000000');
    const {errors}=this.state;
    const updatedFormErrors={...errors};
    const res = await contentService.details(`${testId}testpapers`)
    const courseId=_.get(this.state,"selectedTest.courseId","");
    const apiError=await this.checkIfTestExistInGoal(res.contentId,courseId);
    if(apiError){
      updatedFormErrors.mappedTestValid=apiError; 
    }else{
      updatedFormErrors.mappedTestValid='';
    }
    const { content: { data : { questionsCount = 0}}} = res;
    let selectedTest = { ...this.state.selectedTest}
    selectedTest.questionsCount = questionsCount;
    selectedTest.contentId = contentId;
    
    this.setState({
      overAllData: { ...this.state.overAllData, type: code, testId, contentId },
      selectedTest: selectedTest,
      errors:updatedFormErrors
    });
  };

  isEmpty = (value: any) => {
    return value === '' ? false : true;
  };

  isSubmitEnabled = () => {
    const { selectedTest, goalsDriller, errorBool, selectTouch, phaseBool } = this.state;
    const { errors } = this.state;
    const { testType, isExtraTests } = this.props;
    const isMaxAttemptRequired = testType !== 'week' && !isExtraTests;
    
    if (
      this.isEmpty(selectedTest.displayName) &&
      this.isEmpty(selectedTest.scheduleDate) &&
      this.isEmpty(selectedTest.paperDetail) &&
      this.isEmpty(selectedTest.duration) &&
      this.isEmpty(selectedTest.paperDetail.syllabus) &&
      (Number(selectedTest.questionsCount) > 0 && Number(selectedTest.questionsCount) <= 500) &&
      (isMaxAttemptRequired ? (Number(selectedTest.maxAttempt) !== 0 &&
      errors.maxAttempt === '') : true) &&
      errors.testName === '' &&
      errors.testSyllabus === '' &&
      errors.questionsCount === '' &&
      errors.duration === '' &&
      errors.goal === '' &&
      !errorBool && !phaseBool &&
      selectTouch && errors.mappedTestValid===''
    ) {
      return true;
    } else return false;
  };

  getSearchResult = (searchText: string) => {
    const { testType, test } = this.props;
    let mainTestTypes=['full','part','combined'];
    let contentSubTypeCode = 'phase';
    if( testType === 'week'){
       if(!mainTestTypes.includes(test.type)){
          mainTestTypes.push(test.type);
       }
      contentSubTypeCode=mainTestTypes.join(',');
    }

    if (searchText) {
      const payload = {
        searchText,
        goalsDriller: { ...this.state.goalsDriller },
        testType: contentSubTypeCode
      };
      
      setTimeout(() => this.props.fetchMapTestSuggestions(payload), 1000);
    }
  };

  setGoalsDriller = async (courseId: string) => {
    if(courseId !== ''){
      const res = await courseManagementServices.getCourseDetails(courseId);
      const { courseType, id, groupId, name, targetYear, _id } = res;
      if (res && Object.keys(res).length) {
        const goals = {
          level: 'course',
          course: { courseType, id, groupId, name, targetYear, _id },
        };
        this.setState({
          goalsDriller: {
            ...goals,
          }
        })
      }

    }
  }

  handleCTAClick = () => {
    this.props.handleAddTest && this.props.handleAddTest(this.state.selectedTest);
    this.handleToggleOpen();
  };

  onSaveComboButton = () => {
    const { classes, dialogButtonName, isPreview, editTestDetails } = this.props;
    let conflictPhase = false;
    let previousStartDate = editTestDetails && editTestDetails.startDate;
    let previousEndDate = editTestDetails && editTestDetails.endDate ? editTestDetails.endDate : null;
    editTestDetails && editTestDetails.conflict && (
      conflictPhase = true
    );
    return <>
      <Button
        variant='contained'
        color='primary'
        className={classes.button}
        onClick={() => this.props.onSaveCombo && this.props.onSaveCombo(this.state.overAllData, this.props.testIndex, this.props.editMode, conflictPhase, previousStartDate, previousEndDate)}
        disabled={!this.isSubmitEnabled()}
      >
        {this.props.editMode ? 'Update Test' : dialogButtonName}
      </Button>
    </>

  }

  CTAButton = () => {
    const { classes, dialogButtonName, isPreview } = this.props;
    return <>
      <Button
        variant='contained'
        color='primary'
        onClick={this.handleCTAClick}
        className={classes.button}
        disabled={!this.isSubmitEnabled()}
      >
        {dialogButtonName}
      </Button>
    </>
  }

  renderIsMapComponent = (isPreview: any) => {
    const{classes}=this.props;
    return (
      <>
        {this.state.isTestMapped ? (
         <>{_.get(this.state,"errors.mappedTestValid",'') && (
          <Typography
            // className={classes.errorText}
            variant="caption"
            color="error"
          >
            {_.get(this.state,"errors.mappedTestValid",'')}
          </Typography>
        )}
          <TextField
            id='outlined-bare'
            fullWidth={true}
            margin='normal'
            variant='outlined'
            defaultValue={this.props.mappedTest || this.state.mapTestName}
            disabled={this.state.isTestMapped || isPreview}
          />
        </>  
        )
          :
          (<MyPATMultiSearch
            options={this.state.mapTestSuggestionNames}
            labelKey='title'
            valueKey='id'
            onChange={this.handleTestMapping.bind(this)}
            isSearchAble
            isCustomFilter
            filtredFunction={this.getSearchResult}
            placeholderText='Enter Test Name/ ID to be mapped'
            error={_.get(this.state,"errors.mappedTestValid",'') !== ''}
            errorText={_.get(this.state,"errors.mappedTestValid",'')}
          />)}
      </>
    )
  }


  render() {
    const { check } = this.state;
    const {
      title,
      dropDownStringArray,
      textFieldStringArray,
      dialogButtonName,
      isExistingTest,
      durationAttemptRevision,
      buttonName,
      isPreview,
      isRequiredMapTest,
      isExistingAndScheduledTest,
      isRequiredDate,
      classes,
      handleToggleOpen,
      open,
    } = this.props;
    let isMapTest = isPreview ? false : isRequiredMapTest;
    return (
      <div>
        <MyPATDialog
          onDialogClose={() => handleToggleOpen()}
          aria-labelledby='customized-dialog-title'
          dialogOpen={open}
          dialogHeading={
            <>
              {this.props.editMode ? 'Edit Test' : title}
            </>
          }
          className={classes.dialogBox}
          isborderDialogAction={true}
          customButtonVariant="withoutBorderCloseIcon"
          isCustomBackground={false}
          otherDialogProps={{
            fullWidth: true,
            // maxWidth: 'sm',
          }}
          isApplyCustom
          isfixedDialogActions
          customDialogActions={
            <>
              {!this.props.isPreview ? this.props.fromCombo ? (
                this.onSaveComboButton()
              ) : this.CTAButton() : <></>}
            </>

          }
        >
          <div className={classes.division}>
            {isExistingAndScheduledTest && !this.props.editMode && this.handleRadioButton()}
            <div className={classes.division}>
              {!isPreview && this.handleDropDown(dropDownStringArray)}
              {!isPreview && !check && isExistingTest && (
                <>
                  <Grid className={classes.customSelect}>
                    <Typography>Select Existing Scheduled Test</Typography>
                    <MyPATSelect
                      value={this.state.selectedTest.paperDetail && this.state.selectedTest.paperDetail.id}
                      name='selectedTest'
                      onChange={(e: any) => this.handleChange(e)}
                    >
                      {/* {this.renderSelectTestOptions()} */}
                      {this.state.selectOptions}
                    </MyPATSelect>
                  </Grid>
                </>
              )}
              {this.handleTextField(textFieldStringArray)}
              <div>{isRequiredDate && this.handleStartEndDate()}</div>
              <div>
              <Grid className={[classes.manageField, classes.customGrid].join(' ')}>
                  {this.handleDuration(durationAttemptRevision)}
                </Grid>
              </div>
              {isMapTest && (
                <>
                  <Typography className={classes.inputLable}>
                    Map Test <span> (Optional, can be done later)</span>
                  </Typography>
                  {this.renderIsMapComponent(isPreview)}
                </>
              )}
            </div>
          </div>
        </MyPATDialog>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  existingScheduledTests: state.courseMangementData.courseManagementReducer.existingScheduledTests,
  mapTestSuggestions: state.courseMangementData.courseManagementReducer.mapTestSuggestions,
  goals: state.courseMangementData.courseManagementReducer.activeGoals,
  tests: state.courseMangementData.courseManagementReducer.testSeries.existingScheduledTests,
  coursesByScheduleId: state.courseMangementData.courseManagementReducer.coursesByScheduleId,
  courses: state.courseMangementData.courseManagementReducer.activeCourses,
  totalGoalsForComboCourse: state.courseMangementData.contentManagementData.totalGoalsForComboCourse,
  scheduledTestData: state.courseMangementData.courseManagementReducer.scheduledTests,
  treeData: state.courseMangementData.contentManagementData.treeData,
  viewPlanData: state.courseMangementData.contentManagementData.viewPlanData,

});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      fetchExistingScheduledTests: courseManagementActions.fetchExistingScheduledTests,
      fetchMapTestSuggestions: courseManagementActions.fetchMapTestSuggestions,
      getActiveGoals: getActiveGoals,
      fetchCoursesByScheduleId: courseManagementActions.fetchCoursesByScheduleID,
      fetchScheduleTests: courseManagementActions.fetchScheduleTests
    },
    dispatch
  );

// @ts-ignore
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseStyles)(withRouter(AddTestDialog)));